var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathingDashboardUnselected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1111 19.8889H13.6667V16H12.1111V19.8889ZM18.3333 19.8889H19.8889V12.1111H18.3333V19.8889ZM15.2222 19.8889H16.7778V17.5556H15.2222V19.8889ZM15.2222 16H16.7778V14.4444H15.2222V16ZM10.5556 23C10.1278 23 9.76157 22.8477 9.45694 22.5431C9.15231 22.2384 9 21.8722 9 21.4444V10.5556C9 10.1278 9.15231 9.76157 9.45694 9.45694C9.76157 9.15231 10.1278 9 10.5556 9H21.4444C21.8722 9 22.2384 9.15231 22.5431 9.45694C22.8477 9.76157 23 10.1278 23 10.5556V21.4444C23 21.8722 22.8477 22.2384 22.5431 22.5431C22.2384 22.8477 21.8722 23 21.4444 23H10.5556ZM10.5556 21.4444H21.4444V10.5556H10.5556V21.4444Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingDashboardUnselected);
export default __webpack_public_path__ + "static/media/breathing_dashboard_unselected.272428b9067aa7eb308a7343e397a2df.svg";
export { ForwardRef as ReactComponent };